import DefaultFeatureSetToSummaryFeatures from './defaultSummaryFeatures';
import SummaryFeatureRules from './featureRules';
import summaryFeaturesTransformer from './summaryFeaturesTransformer';
import { formatSummaryFeature } from '~app/pages/Pricing/lib/packageFeatures';

// Standard monthly has one special quirk where we advertise support differently,
// so override that particular rule
export default summaryFeaturesTransformer(DefaultFeatureSetToSummaryFeatures, {
  ...SummaryFeatureRules,
  support: () => formatSummaryFeature('email_support'),
  statistical_significance: () => formatSummaryFeature('text_analysis'),
});

export type SummaryFeaturesTransformerType = typeof summaryFeaturesTransformer;
